import React from 'react';
/**
 *
 * Play symbol SVG
 *
 */
function PlayButton() {
  return (
    <svg
      width="100%"
      height="100%"
      version="1.1"
      xmlns="https://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      className="play"
    >
      <g className="play_circle">
        <circle
          className="shadow"
          cx="50"
          cy="50"
          r="40"
          stroke="rgba(0,0,0,0.1)"
          strokeWidth="10"
          shapeRendering="optimizeQuality"
          fill="none"
        />
        <circle
          className="line"
          cx="50"
          cy="50"
          r="40"
          stroke="white"
          strokeWidth="5"
          fill="none"
        />
      </g>

      <g className="play_arrow">
        <path
          className="shadow"
          stroke="rgba(0,0,0,0.1)"
          strokeWidth="10"
          strokeLinejoin="round"
          fill="none"
          d="M 70,50 40,65 40,35 z"
        />

        <path
          className="line"
          stroke="white"
          strokeWidth="5"
          strokeLinejoin="round"
          fill="none"
          d="M 70,50 40,65 40,35 z"
        />
      </g>
    </svg>
  );
}

export default PlayButton;



// WEBPACK FOOTER //
// ./src/layout/graphics/PlayButton.js